import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_ALL_SPECIALTY } from "src/api-setup/api-endpoints";

export const getAllSpecialty = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_filter: null,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, GET_ALL_SPECIALTY, null, apiHeaders, requestBody, dispatch);

    return response;
  } catch (error) {
    console.error("Error fetching all specialty:", error);
    return [];
  }
};
